import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import classNames from 'classnames';

import closeIcon from '../../assets/images/closeIcon.svg';

import classes from './styles.module.scss';

const TUTORIAL_VIDEOS = [
  {
    title: 'Getting Started',
    videoId: 'P3xlEiCet-8',
  },
  {
    title: 'Snap SOP Tutorial How to Add a Folder',
    videoId: 'Fw_mLkXq_rw',
  },
  {
    title: 'Snap SOP Tutorial How to Add a User',
    videoId: 'Dux78JP-qOg',
  },
  {
    title: 'Snap SOP Tutorial How to Create a Training Path',
    videoId: 'cfkQImzd0-4',
  },
  {
    title: 'Snap SOP Tutorial How to View and Download User Reports',
    videoId: 'upxdRTiI0xE',
  },
  {
    title: 'Snap SOP Tutorial How to Edit a Existing Video',
    videoId: '8seTpAsbUWg',
  },
  {
    title: 'Snap SOP Tutorial How to Create and Use Templates',
    videoId: '4t-D1cVVQ18',
  },
  {
    title: 'Snap SOP Tutorial How to Transfer Folder to Another User',
    videoId: 'zcWmkHsvOas',
  },
  {
    title: 'Snap SOP Tutorial: How to Create a Video',
    videoId: 'DI09CCCAzIY',
  },
];

export default function OnboardingVideoModal({ show, handleClose }) {
  const [selectedVideo, setSelectedVideo] = useState(TUTORIAL_VIDEOS[0]);
  const [searchInput, setSearchInput] = useState('');

  const filteredVideos = useMemo(() => {
    const normalizedSearch = searchInput.trim().toLowerCase();

    if (!normalizedSearch) {
      return TUTORIAL_VIDEOS;
    }

    return TUTORIAL_VIDEOS.filter((video) =>
      video.title.toLowerCase().includes(normalizedSearch)
    );
  }, [searchInput]);

  useEffect(() => {
    if (show) {
      setSelectedVideo(TUTORIAL_VIDEOS[0]);
      setSearchInput('');
    }
  }, [show]);

  const onClose = () => {
    localStorage.setItem('onboardingVideoSeen', 'true');
    handleClose();
  };

  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.OnboardingVideoModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
      onHide={onClose}
    >
      <i className={classes.closeIcon} onClick={onClose}>
        <img src={closeIcon} alt="Close" />
      </i>
      <div className={classes.content}>
        <div className={classes.tutorialViewer}>
          <aside className={classes.sidebar}>
            <input
              type="search"
              value={searchInput}
              onChange={(event) => setSearchInput(event.target.value)}
              className={classes.searchInput}
              placeholder="Search tutorials"
              aria-label="Search tutorials"
            />
            <nav className={classes.videoList} aria-label="SnapSOP tutorials">
              {filteredVideos.map((video) => {
                const videoIndex = TUTORIAL_VIDEOS.findIndex(
                  (tutorialVideo) => tutorialVideo.videoId === video.videoId
                );

                return (
                  <button
                    key={video.videoId}
                    type="button"
                    title={video.title}
                    className={classNames(classes.videoButton, {
                      [classes.active]: selectedVideo.videoId === video.videoId,
                    })}
                    onClick={() => setSelectedVideo(video)}
                  >
                    <span className={classes.videoNumber}>{videoIndex + 1}</span>
                    <span className={classes.videoTitle}>{video.title}</span>
                  </button>
                );
              })}
            </nav>
          </aside>
          <div className={classes.videoPanel}>
            <h3>{selectedVideo.title}</h3>
            <div className={classes.videoWrapper}>
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideo.videoId}?rel=0`}
                title={selectedVideo.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
